import axiosInstance from "../Core/RestHelper"
import { UserResponse, VerifyAwsResponse } from "../Model/User"

const userDashboard=()=>{
    return axiosInstance.get<UserResponse>('users/dashboard')
}

const createAwsClient=(role_arn:string, region:string)=>{
    return axiosInstance.post('aws/client',{role_arn:role_arn,region:region})
}

const verifyAwsConnection=(role_arn:string)=>{
    return axiosInstance.post<VerifyAwsResponse>(`aws/verify/${role_arn}`)
}

export {userDashboard, createAwsClient, verifyAwsConnection}